import { render } from "./UserAnagraph.vue?vue&type=template&id=7adfb43e&ts=true"
import script from "./UserAnagraph.vue?vue&type=script&lang=ts"
export * from "./UserAnagraph.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/UserInfo/UserAnagraph.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7adfb43e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7adfb43e', __exports__)) {
    api.reload('7adfb43e', __exports__)
  }
  
  module.hot.accept("./UserAnagraph.vue?vue&type=template&id=7adfb43e&ts=true", () => {
    api.rerender('7adfb43e', render)
  })

}


export default __exports__